import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsProfiles = (areaSelectedId) => apiActionCreator({
  'endpoint': `/wts/catalog/profiles?area=${areaSelectedId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_PROFILES,
    ActionTypes.FETCHED_WTS_PROFILES,
    [
      ActionTypes.FETCHED_WTS_PROFILES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const createWtsProfiles = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/profiles?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_PROFILES,
        [
          () => {
            dispatch(getWtsProfiles(areaSelectedId));
            return {'type': ActionTypes.CREATED_WTS_PROFILES};
          },
          MessageActions.addMessageBoxInfo('Perfil creado satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_PROFILES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWtsProfiles = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/profiles?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_PROFILES,
        [
          () => {
            dispatch(getWtsProfiles(areaSelectedId));
            return {'type': ActionTypes.UPDATED_WTS_PROFILES};
          },
          MessageActions.addMessageBoxInfo('Perfil actualizado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_PROFILES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const changeWtsProfileSelected = (profileSelected) => ({
  'type': ActionTypes.CHANGE_WTS_PROFILE_SELECTED,
  'payload': profileSelected,
});
